import run from '../../../utilities/run';
import render from "../../../utilities/render";
import { isPresent } from "../../../utilities/general";
import SubmitModalFlow from "../../../components/SubmitModalFlow/SubmitModalFlow";
import EditChecker from '../../../components/EditChecker/EditChecker';
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT, SUCCESS_MODAL_TIMEOUT } from "../../../constants";
const modalHtml = require("../../../sharedHtml/modal.html");
const duplicateDiscrepanciesModalBodyHtml = require("../html/duplicateDiscrepanciesModalBody.html");

const elsPage = {
};

const addDiscrepancyBlockHtml = require("../html/manageDiscrepancyCodes.html");
const customValidateProps = {
  errorPlacement: function (error, element) {
    let appendClosest = $(element).data('error-placement-append-closest');
    if (appendClosest) {
      $(element).closest(appendClosest).append(error);
    } else {
      error.insertAfter(element);
    }
  }
};

const targetSelector = "#manage-receiving-discrepencies";

run(targetSelector, (outerEl) => {
  let duplicateDiscrepanciesModal = "";
  const $ = require('jquery');
  const lookupUrl = $(targetSelector).data("lookup-url");
  const discrepancyCodesList = $(targetSelector).data("discrepancy-list");
  const fieldValidationUrl = $(targetSelector).data("validatiion-form-field-url");
  const duplicaterecordCheckUrl = $(targetSelector).data("duplicate_record-check-url");
  const date = new Date();

  //enabled readonly and disabled field , when failed checbox is selected
  $("#failedRecord").on('change', function () {
    if ($(this).is(':checked')) {
      $("#shippedFrom").attr('readonly', false);
      $("#carrierBolTrackingNum").attr('readonly', false);
      $("#poTrfNum").attr('readonly', false);
      $("#shipmentNumber").attr('readonly', false);
      $("#itemNumber").attr('readonly', false);
      $("#totalPallets").attr('readonly', false);
      $("#discrepantPallets").attr('readonly', false);
      $("#discrepancyQty").attr('readonly', false);

      $("#discrepancyComment").attr('readonly', false);
      $("#status").attr('readonly', false);
      $("#disabledEditCodes").attr('disabled', false);

      $("#photo").attr('disabled', false);
      $("#dateSent").attr('disabled', false);
      $("#dateReceived").attr('disabled', false);
    } else {
      $("#shippedFrom").attr('readonly', true);
      $("#carrierBolTrackingNum").attr('readonly', true);
      $("#poTrfNum").attr('readonly', true);
      $("#shipmentNumber").attr('readonly', true);
      $("#itemNumber").attr('readonly', true);
      $("#totalPallets").attr('readonly', true);
      $("#discrepantPallets").attr('readonly', true);
      $("#discrepancyQty").attr('readonly', true);

      $("#discrepancyComment").attr('readonly', true);
      $("#status").attr('readonly', true);
      $("#disabledEditCodes").attr('disabled', true);

      $("#photo").attr('disabled', true);
      $("#dateSent").attr('disabled', true);
      $("#dateReceived").attr('disabled', true);
    }

  });

  //datepicker event on resolved date click
  $("#resolvedDate").datepicker(
    {
      endDate: date,
      dateFormat: "mm /dd / yyyy",
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    });

  //date picker , cage date should always be equal to lesser than current date
  $("#dateSent").datepicker(
    {
      endDate: date,
      startDate: getCageStartDate(),
      dateFormat: "mm /dd / yyyy",
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true
    }).on('changeDate', function (selected) {
      $("#dateReceived").datepicker('update', '');
      $("#mandatory-date-cage-error").hide();
      var maxReceivedDate = $("#dateSent").datepicker("getDate");
      $('#dateReceived').datepicker('setEndDate', maxReceivedDate);
      var minReceivedDate = new Date(selected.date.valueOf() - (1000 * 60 * 60 * 24 * 30));
      $('#dateReceived').datepicker('setStartDate', minReceivedDate);
    });

  function getCageStartDate() {
    var date = new Date();
    var day = date.getDay();
    var startDate = new Date();

    if (day != 6) {
      startDate.setDate(date.getDate() - (day + 1));
    } else {
      startDate.setDate(date.getDate());
    }

    if (startDate.getMonth() < date.getMonth()) {
      var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
      startDate = new Date(firstDayOfMonth);
    }
    return startDate;
  }

  //date picker , receieved date should always be equal to lesser than current date
  $("#dateReceived").datepicker(
    {
      dateFormat: "mm /dd / yyyy",
      todayBtn: "linked",
      keyboardNavigation: false,
      autoclose: true,
      forceParse: false
    }).on('click', function (date) {
      if ($("#dateSent").datepicker("getDate") === null) {
        $("#mandatory-date-cage-error").show();
        $(this).datepicker('update', '');
        $(this).datepicker('hide');
        return;
      }
    });

  //hide hidden fields on change event
  $("#resolved-comments").on("change", function () {
    if ($("#resolved-comments").is('[readonly]')) {
      return;
    }

    $("#mandatory-resolution-comments").hide();
  });

  //hide hidden fields on change event
  $(".validate-po").on("change", function () {
    $(".submit-verizon-form").attr('disabled', false);
    $("#po-number-do-not-exist-error").hide();
    $("#po-number-is-not-valid").hide();
    $("#po-number-not-provided").hide();
    $("#order-number-do-not-exist-error").hide();
    $("#ship-number-is-not-valid").hide();

    if (!isPresent($(".validate-po").val())) {
      return;
    }
    //empty out shipId and Item#
    $("#shipmentNumber").val('');
    $("#itemNumber").val('');

    var validateValues = {
      "po": $(".validate-po").val()
    };
    validatePo(validateValues);
  });

  //hide hidden fields on change event
  $("#shipmentNumber").on("change", function () {
    $(".submit-verizon-form").attr('disabled', false);
    $("#order-number-do-not-exist-error").hide();
    $("#ship-number-is-not-valid").hide();
    $("#sku-number-do-not-exist-error").hide();

    if (!isPresent($("#shipmentNumber").val())) {
      return;
    }

    if ($("#shipmentNumber").val().length == 0) {
      $("#po-number-do-not-exist-error").show();
      $(".submit-verizon-form").attr('disabled', true);
      return;
    }

    if ($(".validate-po").val().length == 0) {
      $("#po-number-do-not-exist-error").show();
      $(".submit-verizon-form").attr('disabled', true);
      return;
    }

    $("#itemNumber").val('');

    var validateValues = {
      "po": $(".validate-po").val(), "shipId": $("#shipmentNumber").val()
    };

    validateShipId(validateValues);

  });

  //asynchronous validation before submit, PO and shipId field is mandatory 
  $("#itemNumber").on("change", function () {
    $("#po-number-is-not-valid").hide();
    $("#ship-number-is-not-valid").hide();
    $("#po-number-do-not-exist-error").hide();
    $("#sku-number-do-not-exist-error").hide();
    $("#order-number-do-not-exist-error").hide();
    $(".submit-verizon-form").attr('disabled', false);

    if (!isPresent($("#itemNumber").val())) {
      return;
    }

    if ($(".validate-po").val().length == 0) {
      $("#po-number-do-not-exist-error").show();
      $(".submit-verizon-form").attr('disabled', true);
      return;
    }

    if ($("#po-number-is-not-valid").is(":visible")) {
      $(".submit-verizon-form").attr('disabled', true);
      return;
    }

    if ($("#shipmentNumber").val().length == 0) {
      $("#order-number-do-not-exist-error").show();
      $(".submit-verizon-form").attr('disabled', true);
      return;
    }

    if ($("#ship-number-is-not-valid").is(":visible")) {
      $(".submit-verizon-form").attr('disabled', true);
      return;
    }

    var validateValues = {
      "po": $(".validate-po").val(), "shipId": $("#shipmentNumber").val(),
      "itemName": this.value
    };

    validateItem(validateValues);
  });

  //Validate required fields before form submit
  $(".manage-vsigma-form").validate(customValidateProps);

  //submit button click event in form
  $(".submit-verizon-form").click(function (event) {
    event.preventDefault();

    if ($(".manage-vsigma-form").valid()) {
      checkIfRecordIsDuplicate();
    }
  });

  //click event on lookup page update button
  $(".update-verizon-form").click(function (event) {
    $("#mandatory-resolution-comments").hide();
    event.preventDefault();

    //enable disabled discrepancyCodes for edit
    if ($("#disabledEditCodes").is(':disabled')) {
      $("#disabledEditCodes").removeAttr('disabled');
    }

    if ($("#dateSent").is(':disabled')) {
      $("#dateSent").removeAttr('disabled');
    }

    if ($("#dateReceived").is(':disabled')) {
      $("#dateReceived").removeAttr('disabled');
    }

    if ($("#photo").is(':disabled')) {
      $("#photo").removeAttr('disabled');
    }

    //resolution comments must be provided if resolution date is provided
    if (!$("#resolvedDate").val().length == 0) {
      if ($("#resolved-comments").val().length == 0) {
        $("#mandatory-resolution-comments").show();
        return;
      }
    }

    if ($(".manage-vsigma-form").valid()) {
      $("#receivingDiscrepenciesForm").submit();
      var submitModalFlow = new SubmitModalFlow();
      submitModalFlow.init();
      EditChecker.setPageClean();
      submitModalFlow.showLoadingModal();
      submitModalFlow.showSuccessModal();
      setTimeout(function () {
        submitModalFlow.hideAllModals();
      }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
    }

  });

  //check if class is disabled
  function shallAllowClick(currentObj) {
    return !$(currentObj).hasClass("disabled");
  }

  //Generate popup if user trying to enter duplicate record
  function generateWarningModal() {
    duplicateDiscrepanciesModal = $(render(
      modalHtml,
      {
        title: 'Discrepancy already exist , click continue if you want to create same record again',
        leftAlignTitle: true,
        body: duplicateDiscrepanciesModalBodyHtml,
        modalDialogClass: "q-modal-dialog-800",
        topCloseBtn: true,
        autoHideTop: true,
        footerBtns: `
        <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>
        <a  href="#" class="base-btn purple-btn custom-submit-btn submit-duplicate-record">Continue</a>
        `
      }
    ));

    $("body").append(duplicateDiscrepanciesModal);

    duplicateDiscrepanciesModal.modal("show");
    duplicateDiscrepanciesModal.on('hidden.bs.modal', function (e) {
      duplicateDiscrepanciesModal.remove();
    });
  }

  //ajax call to check if discrepancy provided already exists
  function checkIfRecordIsDuplicate() {
    var submitModalFlow = new SubmitModalFlow();
    submitModalFlow.init();

    $.ajax({
      url: duplicaterecordCheckUrl,
      dataType: 'text',
      async: false,
      data: $("#receivingDiscrepenciesForm").serialize(),
      success: function (resp) {
        if (resp == "true") {
          //create warning modal;
          generateWarningModal();

          if (shallAllowClick(this)) {
            $(".submit-duplicate-record").on('click', () => {
              $("#receivingDiscrepenciesForm").submit();
              submitModalFlow.showLoadingModal();
              setTimeout(function () {
                submitModalFlow.hideAllModals();
              }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
            });
          }
        }
        else {
          $("#receivingDiscrepenciesForm").submit();
          EditChecker.setPageClean();
          submitModalFlow.showLoadingModal();
          submitModalFlow.showSuccessModal();
          setTimeout(function () {
            submitModalFlow.hideAllModals();
          }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
        }
      },
      error: function (xhr, status, error) {
        submitModalFlow.hideAllModals();
      }
    });
  }

  //ajax call to check if PO/Ship#/Item# combination is valid
  function validatePo(requestParameters) {
    $.ajax({
      url: fieldValidationUrl,
      data: requestParameters,
      beforeSend: function () {
        $.blockUI({ message: "Validating PO, Please Wait.." });
      },
      complete: function () {
        $.unblockUI();
      },
      success: function (response) {
        var responseObj = JSON.parse(response);
        if (isPresent(responseObj.errorMessage)) {
          var errorMessage = responseObj.errorMessage.split(":", 2)[0];
          var errorElementId = responseObj.errorMessage.split(":", 2)[1];
          document.getElementById(errorElementId).innerHTML = errorMessage;
          $(".validate-po").focus();
          $("#".concat(errorElementId)).show();
          $(".submit-verizon-form").attr('disabled', true);
          return false;
        }
      }
    });
  }

  //ajax call to check if PO/Ship#/Item# combination is valid
  function validateShipId(requestParameters) {
    $.ajax({
      url: fieldValidationUrl,
      data: requestParameters,
      beforeSend: function () {
        $.blockUI({ message: "Validating shipId, Please Wait.." });
      },
      complete: function () {
        ;
        $.unblockUI();
      },
      success: function (response) {
        var responseObj = JSON.parse(response);
        if (isPresent(responseObj.errorMessage)) {
          var errorMessage = responseObj.errorMessage.split(":", 2)[0];
          var errorElementId = responseObj.errorMessage.split(":", 2)[1];
          $("#shipmentNumber").focus();
          document.getElementById(errorElementId).innerHTML = errorMessage;
          $("#".concat(errorElementId)).show();
          $(".submit-verizon-form").attr('disabled', true);
          return false;
        }
      }
    });
  }
  //ajax call to check if PO/Ship#/Item# combination is valid
  function validateItem(requestParameters) {
    $.ajax({
      url: fieldValidationUrl,
      data: requestParameters,
      beforeSend: function () {
        $.blockUI({ message: "Validating item, Please Wait.." });
      },
      complete: function () {
        $.unblockUI();
      },
      success: function (response) {
        var responseObj = JSON.parse(response);
        if (!isPresent(responseObj.errorMessage)) {
          $("#packingListQty").val(responseObj.packageQty);
          $("#vendorSupplier").val(responseObj.vendorSupplier);
          $("#skuDesc").val(responseObj.itemDesc);
          $("#itemExistsOnPo").val(responseObj.itemExistsOnPO);
        }
        else {
          var errorMessage = responseObj.errorMessage.split(":", 2)[0];
          var errorElementId = responseObj.errorMessage.split(":", 2)[1];
          $("#itemNumber").focus();
          document.getElementById(errorElementId).innerHTML = errorMessage;
          $("#".concat(errorElementId)).show();
          $(".submit-verizon-form").attr('disabled', true);
          return false;
        }
      }
    });
  }
});


// WEBPACK FOOTER //
// ./src/pages/receivingDiscrepancies/frontPage/receivingDiscrepanciesForm.js